import { EVENT_SHEET_TITLE_HEIGHT } from '@/components/event-sheet/EventSheetTitle';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { Handle, MODAL_HANDLE_HEIGHT } from '@/feature/alerts/components/Modal';
import { CircularPagerSheetHandleGestureWrapper } from '@/feature/circular-pager/BottomSheetCircularPagerWrapper';
import { useScrollableModalContext } from '@/feature/circular-pager/ScrollableModalContextProvider';
import { Event } from '@/feature/event-details-sbk/types';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';
import { common, withOpacity } from '@/styles/styles';

import { SbkEventSheetTitle } from './SbkEventSheetTitle';

export const SbkEventDetailsSheetHandle = ({ event }: { event: Event }) => {
    const { scrollOffset } = useScrollableModalContext();

    if (!event) {
        return null;
    }

    return (
        <CircularPagerSheetHandleGestureWrapper>
            <Box
                position={'absolute'}
                zIndex={1}
                width={'100%'}
                height={EVENT_SHEET_TITLE_HEIGHT + MODAL_HANDLE_HEIGHT}
                overflow={'hidden'}
            >
                <MaxWidthWrapper>
                    <Box backgroundColor={ds.colorToken.background.neutral.base}>
                        <Handle
                            handleColor={withOpacity(ds.colorValue.background.neutral.inverse, 0.15)}
                            handleContainerStyle={common.backgroundColorTransparent}
                        />
                        <SbkEventSheetTitle event={event} scrollOffset={scrollOffset} />
                    </Box>
                </MaxWidthWrapper>
            </Box>
        </CircularPagerSheetHandleGestureWrapper>
    );
};
